/** Валидирует #RRGGBB строку. */
export function isValidHexColor(s: string | null | undefined): s is string {
  return typeof s === 'string' && /^#[0-9a-fA-F]{6}$/.test(s);
}

/** Конвертирует #RRGGBB + alpha → rgba(r, g, b, a). */
export function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/** Возвращает акцентный hex: service_type_color приоритетнее service_color. */
export function resolveSlotAccent(
  typeColor: string | null | undefined,
  serviceColor: string | null | undefined
): string | null {
  if (isValidHexColor(typeColor)) return typeColor;
  if (isValidHexColor(serviceColor)) return serviceColor;
  return null;
}
